import {styled} from '@linaria/react';
import React from 'react';
import {SkeletonBlock} from '../../atoms/Skeletons/SkeletonBlock';

export const NewsLetterSubscriptionSkeleton = () => {
  return (
    <Wrapper>
      <SkeletonBlock $width="80%" $height="32px" />
      <SkeletonBlock $width="90%" $height="36px" />
      <SkeletonBlock $width="70%" $height="20px" />
      <SkeletonBlock $width="100%" $height="48px" />
      <ButtonSkeleton $width="50%" $height="48px" />
      <SkeletonBlock $width="100%" $height="54px" disableSpaceBelow />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const ButtonSkeleton = styled(SkeletonBlock)`
  margin-bottom: 2rem;
`;
